import * as React from "react";
const SvgFiRrUserAlien = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16.985 15.062C18.577 12.998 20 10.432 20 7.861 20 3.526 16.411 0 12 0S4 3.526 4 7.861c0 2.572 1.424 5.137 3.015 7.201C4.572 16.473 3 19.126 3 22v1a1 1 0 1 0 2 0v-1a6.04 6.04 0 0 1 3.327-5.373c.508.56.997 1.056 1.429 1.47a3.23 3.23 0 0 0 4.488 0 30 30 0 0 0 1.429-1.47A6.04 6.04 0 0 1 19 22v1a1 1 0 1 0 2 0v-1c0-2.874-1.572-5.526-4.015-6.938m-4.127 1.594a1.23 1.23 0 0 1-1.715 0C9.222 14.81 6 11.213 6 7.861 6 4.629 8.691 2 12 2s6 2.629 6 5.861c0 3.352-3.221 6.949-5.142 8.795M16.5 7.219c-.032.637-.176 1.548-.704 2.076s-1.44.672-2.076.704a.683.683 0 0 1-.718-.718c.032-.637.176-1.548.704-2.076s1.44-.672 2.076-.704a.683.683 0 0 1 .718.718m-6.204-.015c.528.528.672 1.44.704 2.076a.683.683 0 0 1-.718.718c-.637-.032-1.548-.176-2.076-.704s-.672-1.44-.704-2.076A.683.683 0 0 1 8.22 6.5c.637.032 1.548.176 2.076.704"
    />
  </svg>
);
export default SvgFiRrUserAlien;
